import { Backdrop } from "@mui/material";

const BlurredBackdrop = ({ children, className }) => (
    <Backdrop open style={{ backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)" }} className={className}>
        {children}
    </Backdrop>
)

export default BlurredBackdrop;